import { Component, OnInit } from '@angular/core';
import { Globals } from "../../_models/globals";
import { AlertService } from '../../_services/alert.service';
import { ApiIntegration } from '../../_services/api.integration';
import { User } from '../../_models/user';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-warehouse-settings-details',
  templateUrl: './warehouse-settings-details.component.html',
  styleUrls: ['./warehouse-settings-details.component.css']
})
export class WarehouseSettingsDetailsComponent implements OnInit {
  warehouseDetails: any = [];
  orderDetails: any = [];
  tabClicked = 'stock_levels';
  constructor(private route: ActivatedRoute, private alertService: AlertService, public user: User, private api: ApiIntegration, private g: Globals) {
    this.api.getWarehouseStock(this.user.accountOwnerId, this.route.snapshot.params['id'], '1').subscribe((data: any) => {
      if (data.getWarehouseStockResponses && data.getWarehouseStockResponses.length) {
        this.warehouseDetails = data.getWarehouseStockResponses[0];
      }
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  ngOnInit(): void {
  }
  populateTabData(status) {
    this.tabClicked = status;
    if (this.tabClicked === 'orders') {
      this.api.getOrdersByWarehouse(this.user.accountOwnerId, this.route.snapshot.params['id'], '1').subscribe((data: any) => {
        if (data.productsHistoryActivities && data.productsHistoryActivities.length) {
          this.orderDetails = data.productsHistoryActivities;
        }
      }, err => {
        this.alertService.error('Error', err);
      });
    }
  }
}
